import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  ADD_USER_STARTING,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
} from '../../constants/actionTypes';

export default function addUserReducer(state = initialState.addUser, action) {
  switch (action.type) {
    case ADD_USER_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_USER_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newUser = data.device;
      return newState;
    }

    case ADD_USER_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
